<template>
  <page-header-wrapper>
    <!-- <JeepayCard title="银行账户"> -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="table-head-ground">
        <div class="table-layer">
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'账号ID'"
              :msg="searchData.accountNo"
              v-model="searchData.accountNo"
            />
          </a-form-item>

          <a-form-item label="" >
            <a-select
              v-model="searchData.accountType"
              placeholder="账户类型"
              default-value=""
              allowClear
              style="width: 150px"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">银行账户</a-select-option>
              <a-select-option value="2">USDT(TRC20)</a-select-option>
            </a-select>
          </a-form-item>
          <span class="table-page-search-submitButtons">
            <a-button
              type="primary"
              icon="search"
              @click="queryFunc"
              :loading="btnLoading"
            >搜索</a-button>
            <a-button
              style="margin-left: 8px"
              icon="reload"
              @click="resetForm"
            >重置</a-button>
          </span>
        </div>
      </a-form>
    </div>

    <!-- 新建账户按钮 -->
    <div style="margin-bottom: 16px;">
      <a-button type="primary" icon="plus" @click="addAccount">
        新建账户
      </a-button>
    </div>

    <!-- 列表渲染 -->
    <JeepayTable
      @btnLoadClose="btnLoading = false"
      ref="infoTable"
      :initData="true"
      :reqTableDataFunc="reqTableDataFunc"
      :tableColumns="tableColumns"
      :searchData="searchData"
      rowKey="id"
      :tableRowCrossColor="true"
    >
      <template slot="accountTypeSlot" slot-scope="{ record }">
        <a-tag :color="getAccountTypeColor(record.accountType)">
          {{ getAccountTypeText(record.accountType) }}
        </a-tag>
      </template>

      <template slot="statusSlot" slot-scope="{ record }">
        <a-tag :color="record.status === 1 ? 'green' : 'red'">
          {{ record.status === 1 ? '启用' : '禁用' }}
        </a-tag>
      </template>

      <template slot="createdAtSlot" slot-scope="{ record }">
        {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
      </template>

      <template slot="opSlot" slot-scope="{ record }">
        <JeepayTableColumns>
          <a-button type="link" @click="editAccount(record)">修改</a-button>
          <a-button type="link" style="color: red" @click="deleteAccount(record)">
            删除
          </a-button>
        </JeepayTableColumns>
      </template>
    </JeepayTable>
    <!-- </JeepayCard> -->

    <!-- 账户表单弹窗组件 -->
    <AccountFormModal
      :visible="modalVisible"
      :loading="modalLoading"
      :isEdit="isEdit"
      :initialData="currentAccountData"
      @submit="handleAccountSubmit"
      @cancel="handleModalCancel"
    />
  </page-header-wrapper>
</template>

<script>
import JeepayCard from '@/components/JeepayCard/JeepayCard'
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp'
import AccountFormModal from './components/AccountFormModal'
import moment from 'moment'
import {
  tableColumns,
  getAccountTypeText,
  getAccountTypeColor
} from './tableColumns'
import { req } from '@/api/manage'
import {
  API_URL_SETTLEMENT_ACCOUNT_LIST,
  API_URL_SETTLEMENT_ACCOUNT_DELETE,
  API_URL_SETTLEMENT_ACCOUNT_ADD,
  API_URL_SETTLEMENT_ACCOUNT_UPDATE
} from '@/api/settlement'

export default {
  name: 'BankAccountManagement',
  components: {
    JeepayCard,
    JeepayTable,
    JeepayTableColumns,
    JeepayTextUp,
    AccountFormModal
  },
  data () {
    return {
      btnLoading: false,
      tableColumns: tableColumns,
      searchData: {},
      modalVisible: false,
      modalLoading: false,
      isEdit: false,
      currentAccountData: {}
    }
  },
  methods: {
    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
    },

    // 请求table接口数据
    reqTableDataFunc: (params) => {
      // 模拟API调用
      return req.getList(API_URL_SETTLEMENT_ACCOUNT_LIST, params)
      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     const mockData = [
      //       {
      //         id: 1,
      //         accountType: 'bank',
      //         bankName: 'ICICI Bank',
      //         accountName: '张三',
      //         bankCardNumber: '1234567890123456',
      //         openProvince: '广东省',
      //         openCity: '深圳市',
      //         openBranchName: '深圳分行',
      //         status: 1,
      //         isDefault: 1,
      //         createdAt: '2024-01-01 10:00:00'
      //       },
      //       {
      //         id: 2,
      //         accountType: 'usdt',
      //         bankName: 'USDT(TRC20)',
      //         accountName: '李四',
      //         bankCardNumber: 'TQn9Y2khEsLJW1ChVWFMSMeRDow5oNDMnt',
      //         networkType: 'TRC20',
      //         usdtAddress: 'TQn9Y2khEsLJW1ChVWFMSMeRDow5oNDMnt',
      //         status: 1,
      //         isDefault: 0,
      //         createdAt: '2024-01-02 11:00:00'
      //       },
      //       {
      //         id: 3,
      //         accountType: 'other',
      //         bankName: '支付宝',
      //         accountName: '王五',
      //         bankCardNumber: '13800138000',
      //         paymentPlatform: 'alipay',
      //         accountNumber: '13800138000',
      //         status: 0,
      //         isDefault: 0,
      //         createdAt: '2024-01-03 12:00:00'
      //       }
      //     ]

      //     resolve({
      //       records: mockData,
      //       total: mockData.length,
      //       current: params.current || 1,
      //       size: params.size || 10
      //     })
      //   }, 500)
      // })
    },

    resetForm () {
      this.$set(this.searchData, 'accountNo', null)
      // this.$set(this.searchData, 'accountType', null)
      delete this.searchData.accountType
      this.$nextTick(() => {
        this.queryFunc()
      })

      // 使用 $nextTick 确保数据更新后再执行查询
      this.$nextTick(() => {
        this.queryFunc()
      })
    },

    // 获取账户类型文本
    getAccountTypeText,

    // 获取账户类型颜色
    getAccountTypeColor,

    // 新建账户
    addAccount () {
      this.isEdit = false
      this.currentAccountData = {}
      this.modalVisible = true
    },

    // 修改账户
    editAccount (record) {
      this.isEdit = true
      this.currentAccountData = { ...record }
      this.modalVisible = true
    },

    // 删除账户
     deleteAccount (record) {
      this.$infoBox.confirmDanger(
        '确认删除？',
        '该操作将删除该账户，且无法恢复',
        async () => {
          await req.delByIdPost(API_URL_SETTLEMENT_ACCOUNT_DELETE, record.id)
          // 这里调用实际的API
          console.log('删除账户:', record.id)
          this.$message.success('删除成功')
          await this.queryFunc()
        }
      )
    },

    // 处理账户提交
    async handleAccountSubmit (submitData) {
      this.modalLoading = true
      try {
        // 这里调用实际的API
        const action = this.isEdit ? '更新' : '创建'
        console.log(`${action}账户:`, submitData)
        const data = {
          ...submitData,
          id: submitData.id
        }

        // 模拟API调用
        if (this.isEdit) {
          await req.updateByIdPost(API_URL_SETTLEMENT_ACCOUNT_UPDATE, data)
        } else {
          // 创建
          // console.log('创建账户:', submitData)
          await req.add(API_URL_SETTLEMENT_ACCOUNT_ADD, submitData)
        }
        // await new Promise(resolve => setTimeout(resolve, 1000))

        this.$message.success(`${action}成功`)
        this.modalVisible = false
        this.queryFunc()
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      } finally {
        this.modalLoading = false
      }
    },

    // 取消弹窗
    handleModalCancel () {
      this.modalVisible = false
      this.currentAccountData = {}
    },

    moment
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
